'use strict';

angular.module('nfseApp')
    .controller('GuiaController', function ($scope, Guia, GuiaSearch) {
        $scope.guias = [];
        $scope.loadAll = function() {
            Guia.query(function(result) {
               $scope.guias = result;
            });
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Guia.get({id: id}, function(result) {
                $scope.guia = result;
                $('#deleteGuiaConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Guia.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteGuiaConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.search = function () {
            GuiaSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.guias = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.guia = {guia: null, valor: null, dataVencimento: null, id: null};
        };
    });
